import { useCallback, useState } from "react";
/**
 * This is a simple hook that will allow you to "strongly" type a `Select`
 * component's value since the `onChange` handler only returns a `string`.
 *
 * @param defaultValue The default value to use
 * @return an ordered list containing the current value followed by the dispatch
 * function to update the state.
 */
export default function useSelectState(defaultValue) {
    var _a = useState(defaultValue), value = _a[0], setValue = _a[1];
    var setTypedValue = useCallback(function (nextValue) {
        setValue(nextValue);
    }, []);
    return [value, setTypedValue];
}
//# sourceMappingURL=useSelectState.js.map